import { useTranslation } from "react-i18next"

export function SubmissionSuccessPage() {
  const { t } = useTranslation()

  return (
    <div className="flex flex-col h-[100vh] mt-20 items-center">
      <div className="flex flex-col max-w-2xl">
        <p className="[font-size:var(--alias-font-display-xl-font-size)] [font-family:var(--alias-font-display-xl-font-family)]">
          {t("client.submission.success.title")}
        </p>
        <div className="my-8 [font-size:var(--alias-font-subtitle-lg-font-size)] [font-family:var(--alias-font-subtitle-md-font-weight)]">
          <p>{t("client.submission.success.subtitle")}</p>
        </div>
      </div>
    </div>
  )
}
